import { SupportPage, UnderDevelopment } from '@components-common/support';
import { ConfigSection } from '../../../components-fabric';
import { layoutWorkspace } from '../../_common/layout.workspace';
import { revitPluginSection } from './revit-plugin.screen';
import { userGuideSection } from './user-guide.screen';

/**
 * Configuration Section: supportSection
 *
 * This configuration section defines the structure and layout for the "Support" area in the application. It includes a set of screens
 * that are accessible to users. The section is not protected and uses a basic template with the `layoutWorkspace` layout.
 * Additionally, it includes nested sections, such as the `revitPluginSection`.
 *
 * Properties:
 * @type {ConfigSection}
 * @property {string} id - The unique identifier for the section ('support').
 * @property {React.ComponentType} layout - The layout component used for this section (`layoutWorkspace`).
 * @property {boolean} protected - Indicates if the section is protected (false).
 * @property {string} tmp - Template used for the section ('basic').
 * @property {Array} screens - List of screens included in this section (`supportScreens`).
 * @property {Array} sections - Additional nested sections, such as `revitPluginSection`.
 */
const supportScreens = [
  {
    id: '',
    path: '',
    roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
    Component: SupportPage,
  },
  {
    id: 'under_development',
    title: 'Under Development',
    Component: UnderDevelopment,
  },
  // {
  //   id: 'help',
  //   title: 'Help',
  //   Component: HelpPage,
  //   children: [
  //     {
  //       id: 'help2',
  //       title: 'Help2',
  //       Component: HelpPage,
  //     },
  //   ],
  // },
];

export const supportSection: ConfigSection = {
  id: 'support',
  layout: layoutWorkspace,
  protected: false,
  tmp: 'basic',
  screens: supportScreens as any,
  sections: [revitPluginSection as any, userGuideSection],
};
